import { TinyColor } from '@ctrl/tinycolor';
import { css, type Theme } from '@emotion/react';

export const bar = (theme: Theme) => css`
  display: inline-flex;
  align-items: center;
  gap: 16px;
  padding: 12px 16px;
  background-color: ${theme.colors.gray[0]};
  border-radius: 8px;
  box-shadow:
    0px 2px 4px ${new TinyColor(theme.colors.gray[900]).setAlpha(0.1).toRgbString()},
    0px 0px 11px 1px ${new TinyColor(theme.colors.gray[900]).setAlpha(0.1).toRgbString()};
`;

export const actions = css`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const actionsList = css`
  && {
    min-width: 260px;
    max-height: 420px;
  }
`;
